import { isNullOrWhiteSpace } from "../utils/utils.js";
export class Address {
    constructor(email, displayName, addressType = "SMTP") {
        this.email = email;
        this.displayName = isNullOrWhiteSpace(displayName) ? email : displayName;
        this.addressType = addressType;
    }
}
